(function () {
  function initFaq(sectionId) {
    var grid = document.getElementById('faq-grid-' + sectionId);
    if (!grid) return;

    function getItems() {
      return grid.querySelectorAll('.question-item');
    }

    // Accordion toggle (event delegation — works for dynamically added items)
    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('.question-toggle');
      if (!btn) return;
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      var item = btn.closest('.question-item');
      if (item) item.classList.toggle('is-open', !expanded);
      var answerId = btn.getAttribute('aria-controls');
      var answer = answerId ? document.getElementById(answerId) : null;
      if (answer) answer.setAttribute('aria-hidden', String(expanded));
    });

    // Expand / Collapse all
    var expandAllBtn = document.getElementById('faq-expand-all-' + sectionId);
    if (expandAllBtn) {
      expandAllBtn.addEventListener('click', function () {
        var allExpanded = this.getAttribute('aria-pressed') === 'true';
        getItems().forEach(function (item) {
          var btn = item.querySelector('.question-toggle');
          if (!btn) return;
          var answerId = btn.getAttribute('aria-controls');
          var answer = answerId ? document.getElementById(answerId) : null;
          btn.setAttribute('aria-expanded', String(!allExpanded));
          item.classList.toggle('is-open', !allExpanded);
          if (answer) answer.setAttribute('aria-hidden', String(allExpanded));
        });
        this.setAttribute('aria-pressed', String(!allExpanded));
        this.textContent = allExpanded ? 'Expand all' : 'Collapse all';
      });
    }

    // Live search
    var input = document.getElementById('faq-search-' + sectionId);
    var noResults = document.getElementById('faq-no-results-' + sectionId);
    var countVisible = document.getElementById(
      'faq-count-visible-' + sectionId
    );
    var countTotal = document.getElementById('faq-count-total-' + sectionId);

    // Re-baseline the denominator to what actually rendered. Liquid seeds it
    // from metaobjects.faq.values_count, a RAW record count that includes
    // duplicate question text (production has two "How much does a hidden door
    // cost?" entries). Those are deduped at render time, so leaving the raw
    // count in place shows a permanently unreachable target ("505 of 506").
    function _syncTotalCount() {
      var total = grid.querySelectorAll('.question-item').length;
      if (!total) return;
      if (countTotal) countTotal.textContent = total;
      if (input) input.placeholder = 'Search ' + total + ' questions…';
    }

    if (input) {
      input.addEventListener('input', function () {
        var q = this.value.trim().toLowerCase();
        var visible = 0;
        getItems().forEach(function (item) {
          var match =
            !q ||
            (item.dataset.q || '').includes(q) ||
            (item.dataset.a || '').includes(q);
          item.hidden = !match;
          if (match) visible++;
        });
        // Collapse category sections that have no surviving questions. Without
        // this a filtered view leaves orphaned headings standing over nothing
        // (searching "warranty" left 5 empty category headings on screen).
        // Neither .faq-category-section nor .question-item sets `display` in
        // CSS, so the UA `[hidden]{display:none}` rule is free to win here.
        grid.querySelectorAll('.faq-category-section').forEach(function (sec) {
          sec.hidden = !sec.querySelector('.question-item:not([hidden])');
        });
        if (countVisible) countVisible.textContent = visible;
        if (noResults) noResults.hidden = visible > 0;
      });
    }

    // Sticky bar + IntersectionObserver (FAQ page only — stickyBar absent on non-FAQ pages)
    var stickyBar = document.getElementById('faq-sticky-bar-' + sectionId);
    var observer = null;

    if (stickyBar) {
      // Measure the sticky header and set --header-height so the bar sticks
      // below it. Also updates --faq-sticky-height for scroll-margin-top on sections.
      function updateStickyLayout() {
        var headerEl = document.querySelector(
          '.shopify-section-group-header-group'
        );
        var headerH = headerEl ? headerEl.offsetHeight : 0;
        document.documentElement.style.setProperty(
          '--header-height',
          headerH + 'px'
        );
        document.documentElement.style.setProperty(
          '--faq-sticky-height',
          stickyBar.offsetHeight + 'px'
        );
      }
      updateStickyLayout();
      window.addEventListener('resize', updateStickyLayout, { passive: true });

      var chips = stickyBar.querySelectorAll('.faq-chip[data-cat]');
      var chipMap = {};
      chips.forEach(function (chip) {
        chipMap[chip.dataset.cat] = chip;
      });

      function setActiveChip(slug) {
        chips.forEach(function (c) {
          c.removeAttribute('aria-current');
        });
        if (slug && chipMap[slug]) {
          chipMap[slug].setAttribute('aria-current', 'true');
          // Scroll chip horizontally into view within the chips container only —
          // scrollIntoView({ block:'nearest' }) on a sticky element causes the page
          // to fight the user's scroll, creating an infinite scroll loop.
          var chip = chipMap[slug];
          var chipsContainer = chip.closest('.faq-cat-chips');
          if (chipsContainer) {
            var chipLeft = chip.offsetLeft;
            var chipRight = chipLeft + chip.offsetWidth;
            var cLeft = chipsContainer.scrollLeft;
            var cRight = cLeft + chipsContainer.offsetWidth;
            if (chipLeft < cLeft) {
              chipsContainer.scrollLeft = chipLeft - 8;
            } else if (chipRight > cRight) {
              chipsContainer.scrollLeft =
                chipRight - chipsContainer.offsetWidth + 8;
            }
          }
        }
      }

      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              setActiveChip(entry.target.id.replace('faq-cat-', ''));
            }
          });
        },
        { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
      );

      grid.querySelectorAll('.faq-category-section').forEach(function (sec) {
        observer.observe(sec);
      });

      // Smooth scroll on chip click with offset for sticky bar + site header
      chips.forEach(function (chip) {
        chip.addEventListener('click', function (e) {
          e.preventDefault();
          var target = document.getElementById('faq-cat-' + this.dataset.cat);
          if (!target) return;
          var headerEl = document.querySelector(
            '.shopify-section-group-header-group'
          );
          var headerH = headerEl ? headerEl.offsetHeight : 0;
          var barH = stickyBar.offsetHeight;
          var top =
            target.getBoundingClientRect().top +
            window.scrollY -
            headerH -
            barH -
            16;
          window.scrollTo({
            top: top,
            behavior:
              typeof window.isIOS !== 'undefined' && window.isIOS
                ? 'auto'
                : 'smooth',
          });
        });
      });
    }

    // Repair quick-answer links: Liquid's handleize strips U+2014 (em dash) from
    // metafield list values but preserves it from metaobject field values, so the
    // generated hrefs can miss the target id. Match by stripped alphanumeric key instead.
    function _repairQuickAnswerLinks() {
      var qaLinks = document.querySelectorAll('.faq-quick-answers a');
      if (!qaLinks.length) return;
      function _norm(s) {
        return s.toLowerCase().replace(/[^a-z0-9]+/g, '');
      }
      var qMap = {};
      document
        .querySelectorAll('.question-item[data-q]')
        .forEach(function (el) {
          qMap[_norm(el.dataset.q)] = el.id;
        });
      qaLinks.forEach(function (a) {
        var key = _norm(a.textContent.trim());
        if (qMap[key]) a.hash = '#' + qMap[key];
      });
    }
    _repairQuickAnswerLinks();
    // Single-page sections never enter the hydration branch below, so
    // re-baseline here too.
    _syncTotalCount();

    // Anchor border-sweep: open accordion + animate border when navigating by hash.
    // CSS :target::after handles static items on page load; JS handles hashchange
    // navigation and items hydrated dynamically after Storefront API fetch.
    function _anchorFlash(el) {
      var btn = el.querySelector('.question-toggle');
      if (btn && btn.getAttribute('aria-expanded') !== 'true') {
        btn.setAttribute('aria-expanded', 'true');
        el.classList.add('is-open');
        var answerId = btn.getAttribute('aria-controls');
        var answer = answerId ? document.getElementById(answerId) : null;
        if (answer) answer.setAttribute('aria-hidden', 'false');
      }
      el.classList.remove('question-item--anchor-flash');
      void el.offsetWidth;
      el.classList.add('question-item--anchor-flash');
      setTimeout(function () {
        el.classList.remove('question-item--anchor-flash');
      }, 1600);
    }

    window.addEventListener('hashchange', function () {
      var id = decodeURIComponent(location.hash.slice(1));
      if (!id) return;
      var el = document.getElementById(id);
      if (el && el.classList.contains('question-item')) _anchorFlash(el);
    });

    if (location.hash) {
      var _ph = decodeURIComponent(location.hash.slice(1));
      var _pe = document.getElementById(_ph);
      if (_pe && _pe.classList.contains('question-item')) {
        setTimeout(function () {
          _anchorFlash(_pe);
        }, 50);
      }
    }

    // Overflow hydration via Storefront API — DORMANT under normal operation.
    // Shopify's Section Rendering API does not honor ?page=N for metaobject
    // pagination — it always returns page 1. So when the corpus does not fit in
    // one paginate page we walk the Storefront API instead, following
    // `hasNextPage` until it is false (NOT a fixed number of calls — see the
    // MAX_PAGES note below, which is a runaway guard, not the page limit).
    //
    // As of 2026-08-06 the section paginates `by 1000` against ~505 published
    // FAQs, so paginate.pages renders 1 and this whole branch is skipped. Do NOT
    // reintroduce the belief that Liquid caps at 250 — that was our own `by 250`
    // literal, never a Shopify ceiling, and assuming otherwise cost the site 255
    // answers of non-JS crawler visibility. This branch re-arms by itself if the
    // corpus ever outgrows the paginate `by`.
    var totalPages = parseInt(grid.dataset.paginatePages || '1', 10);
    if (totalPages > 1) {
      var sfToken = grid.dataset.storefrontToken || '';
      var sfDomain = grid.dataset.shopDomain || '';
      if (!sfToken || !sfDomain) return;

      function _handleize(str) {
        // -￿ preserves non-ASCII Unicode chars (e.g. ®, ™) so this
        // matches Liquid's handleize filter which keeps them rather than removing.
        return String(str)
          .toLowerCase()
          .replace(/[^a-z0-9-￿]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }
      function _escHtml(str) {
        return String(str)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }
      function _escAttr(str) {
        return _escHtml(str).replace(/'/g, '&#39;');
      }
      function _nlToBr(str) {
        return _escHtml(str).replace(/\n/g, '<br>');
      }

      function _addChipFor(slug) {
        var chipsList = document.querySelector('.faq-cat-chips');
        if (!chipsList) return;
        // `slug` is the raw `category` metaobject field (unconstrained merchant
        // free text), so it must be escaped before reaching innerHTML — the
        // label was escaped here but the two attribute interpolations were not.
        // The CSS.escape'd dedupe lookup below also stops a malformed slug from
        // throwing a SyntaxError out of querySelector, which previously aborted
        // the rest of the hydration batch inside the shared .catch().
        var safeSlug = _escAttr(slug);
        var lookup =
          typeof CSS !== 'undefined' && CSS.escape
            ? '[data-cat="' + CSS.escape(slug) + '"]'
            : null;
        if (lookup) {
          if (chipsList.querySelector(lookup)) return;
        } else {
          var existing = chipsList.querySelectorAll('[data-cat]');
          for (var i = 0; i < existing.length; i++) {
            if (existing[i].getAttribute('data-cat') === slug) return;
          }
        }
        var label = slug.replace(/-/g, ' ').replace(/\b\w/g, function (c) {
          return c.toUpperCase();
        });
        var newChip = document.createElement('li');
        newChip.className = 'faq-chip-item';
        newChip.innerHTML =
          '<a class="faq-chip" href="#faq-cat-' +
          safeSlug +
          '" data-cat="' +
          safeSlug +
          '">' +
          _escHtml(label) +
          '</a>';
        chipsList.appendChild(newChip);
        var anchor = newChip.querySelector('.faq-chip');
        if (anchor && stickyBar) {
          anchor.addEventListener('click', function (e) {
            e.preventDefault();
            var target = document.getElementById('faq-cat-' + this.dataset.cat);
            if (!target) return;
            var headerEl = document.querySelector(
              '.shopify-section-group-header-group'
            );
            var headerH = headerEl ? headerEl.offsetHeight : 0;
            var barH = stickyBar.offsetHeight;
            var top =
              target.getBoundingClientRect().top +
              window.scrollY -
              headerH -
              barH -
              16;
            window.scrollTo({
              top: top,
              behavior:
                typeof window.isIOS !== 'undefined' && window.isIOS
                  ? 'auto'
                  : 'smooth',
            });
          });
        }
      }

      function _renderItem(question, answer, tldr) {
        var h = _handleize(question);
        return (
          '<li class="question-item" id="faq-item-' +
          h +
          '" data-q="' +
          _escAttr(question.toLowerCase()) +
          '" data-a="' +
          _escAttr(answer.toLowerCase()) +
          '">' +
          '<h3 class="faq-question-heading"><button class="question-toggle" aria-expanded="false" aria-controls="faq-answer-' +
          sectionId +
          '-' +
          h +
          '">' +
          _escHtml(question) +
          '<span class="plus-icon" aria-hidden="true">+</span></button></h3>' +
          '<div id="faq-answer-' +
          sectionId +
          '-' +
          h +
          '" class="answer accor" aria-hidden="true">' +
          (tldr ? '<p class="faq-tldr">' + _escHtml(tldr) + '</p>' : '') +
          _nlToBr(answer) +
          '</div></li>'
        );
      }

      function _sfQuery(gql) {
        return fetch('https://' + sfDomain + '/api/2025-01/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': sfToken,
          },
          body: JSON.stringify({ query: gql }),
        }).then(function (r) {
          return r.json();
        });
      }

      // Build dedup set from DOM once — question text comparison is handle-format-agnostic.
      // We re-read the DOM before each _mergeNodes call so within-batch additions are tracked.
      function _buildRenderedSet() {
        var s = new Set();
        document
          .querySelectorAll('.question-item[data-q]')
          .forEach(function (el) {
            s.add(el.dataset.q.toLowerCase());
          });
        return s;
      }

      function _mergeNodes(nodes, renderedQs) {
        nodes.forEach(function (node) {
          if (!node || !node.fields) return;
          var fields = {};
          node.fields.forEach(function (f) {
            fields[f.key] = f.value || '';
          });
          var question = fields.question || '';
          var answer = fields.answer || '';
          var category = fields.category || 'general';
          var tldr = fields.tldr || '';
          if (!question || !answer) return;
          var qKey = question.toLowerCase();
          if (renderedQs.has(qKey)) return;
          renderedQs.add(qKey);
          var catSec = document.getElementById('faq-cat-' + category);
          if (!catSec) {
            catSec = document.createElement('section');
            catSec.className = 'faq-category-section';
            catSec.id = 'faq-cat-' + category;
            var label = category
              .replace(/-/g, ' ')
              .replace(/\b\w/g, function (c) {
                return c.toUpperCase();
              });
            catSec.innerHTML =
              '<h2 class="faq-cat-heading">' +
              _escHtml(label) +
              '</h2><ul class="question-grid" role="list"></ul>';
            var noResultsEl = document.getElementById(
              'faq-no-results-' + sectionId
            );
            if (noResultsEl) grid.insertBefore(catSec, noResultsEl);
            else grid.appendChild(catSec);
            if (observer) observer.observe(catSec);
            _addChipFor(category);
          }
          var list = catSec.querySelector('.question-grid');
          if (list)
            list.insertAdjacentHTML(
              'beforeend',
              _renderItem(question, answer, tldr)
            );
        });
      }

      // Rebuild the FAQPage JSON-LD from what is actually in the DOM.
      // Only reached when the corpus overflows the paginate `by` (see the
      // totalPages > 1 gate above). In that case Liquid seeds mainEntity with
      // just the first page, so the emitted schema would describe less than the
      // visible content. Googlebot renders JS and reads JS-injected structured
      // data, so regenerating here is the only way to cover metaobjects that
      // arrive after first paint. Answers are read from the rendered text,
      // guaranteeing schema can never claim content a visitor cannot see.
      function _syncFaqSchema() {
        var el = document.getElementById('faq-ldjson-' + sectionId);
        if (!el) return;
        var parsed;
        try {
          parsed = JSON.parse(el.textContent);
        } catch (e) {
          return;
        }
        if (!Array.isArray(parsed)) return;
        var faqNode = null;
        for (var i = 0; i < parsed.length; i++) {
          if (parsed[i] && parsed[i]['@type'] === 'FAQPage') {
            faqNode = parsed[i];
            break;
          }
        }
        if (!faqNode) return;

        // Read the answer WITHOUT the TL;DR paragraph. `.faq-tldr` is nested
        // inside `.answer`, so a plain ans.textContent concatenates the two
        // with no separator ("Costs vary by size.Most doors run...") and
        // corrupts acceptedAnswer.text. The server-side capture uses
        // `faq.answer.value` alone, so excluding tldr keeps the client-rebuilt
        // schema byte-comparable with the Liquid-seeded entries it replaces.
        // <br> (from newline_to_br) contributes no text, so paragraph breaks
        // are normalised to single spaces rather than lost mid-word.
        function _answerText(ansEl) {
          var out = '';
          var kids = ansEl.childNodes;
          for (var i = 0; i < kids.length; i++) {
            var n = kids[i];
            if (
              n.nodeType === 1 &&
              n.classList &&
              n.classList.contains('faq-tldr')
            ) {
              continue;
            }
            if (n.nodeType === 1 && n.tagName === 'BR') {
              out += ' ';
              continue;
            }
            out += n.textContent;
          }
          return out.replace(/\s+/g, ' ').trim();
        }

        var entities = [];
        var seen = Object.create(null);
        grid.querySelectorAll('.question-item').forEach(function (li) {
          var btn = li.querySelector('.question-toggle');
          var ans = li.querySelector('.answer');
          if (!btn || !ans) return;
          var q = (
            btn.childNodes[0] ? btn.childNodes[0].textContent : ''
          ).trim();
          var a = _answerText(ans);
          if (!q || !a || seen[q]) return;
          seen[q] = 1;
          entities.push({
            '@type': 'Question',
            name: q,
            acceptedAnswer: { '@type': 'Answer', text: a },
          });
        });
        if (!entities.length) return;
        faqNode.mainEntity = entities;
        el.textContent = JSON.stringify(parsed);
      }

      // Storefront API and Liquid use different sort orders, so Liquid page 1
      // and SF page 1 overlap only partially. Walk EVERY Storefront page until
      // hasNextPage is false; _mergeNodes skips anything already rendered
      // (by question text).
      //
      // The previous implementation issued exactly two calls (250 + 250) and
      // its second query did not request pageInfo, so it could not continue —
      // a hard 500-item ceiling. With 506 published FAQs the page rendered a
      // self-contradicting "500 of 506 questions" and six answers were
      // permanently unreachable. MAX_PAGES below is a runaway guard, NOT the
      // pagination limit.
      var _nodeFields = 'nodes { fields { key value } }';
      var _rendered = _buildRenderedSet();
      var MAX_PAGES = 40;

      function _escCursor(c) {
        return String(c).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      }

      function _fetchPage(cursor, pageNum) {
        var args = 'type: "faq", first: 250';
        if (cursor) args += ', after: "' + _escCursor(cursor) + '"';
        return _sfQuery(
          '{ metaobjects(' +
            args +
            ') { pageInfo { endCursor hasNextPage } ' +
            _nodeFields +
            ' } }'
        ).then(function (data) {
          var mo = data && data.data && data.data.metaobjects;
          if (!mo) return;
          _mergeNodes(mo.nodes || [], _rendered);
          var info = mo.pageInfo;
          if (!info || !info.hasNextPage || !info.endCursor) return;
          if (pageNum >= MAX_PAGES) {
            console.warn(
              '[FAQ hydration] page cap reached; some FAQs may be missing'
            );
            return;
          }
          return _fetchPage(info.endCursor, pageNum + 1);
        });
      }

      _fetchPage(null, 1)
        .catch(function (e) {
          console.error('[FAQ Storefront hydration]', e);
        })
        .then(function () {
          _repairQuickAnswerLinks();
          if (countVisible && (!input || !input.value)) {
            countVisible.textContent =
              grid.querySelectorAll('.question-item').length;
          }
          _syncTotalCount();
          _syncFaqSchema();
          if (location.hash) {
            var hashId = decodeURIComponent(location.hash.slice(1));
            var hashEl = document.getElementById(hashId);
            if (hashEl && hashEl.classList.contains('question-item'))
              _anchorFlash(hashEl);
          }
        });
    }
  }

  document
    .querySelectorAll('[data-faq-section-id]')
    .forEach(function (wrapper) {
      initFaq(wrapper.dataset.faqSectionId);
    });
})();
